import { Component } from '@angular/core';

import { ActionSheet, Events, ActionSheetController, Config, NavController, ToastController } from 'ionic-angular';
import { PopoverController} from 'ionic-angular';
import { UEData } from '../../providers/ue-data';
import { UECreatePage } from '../ue/ue-create';
import { UEEditPage } from './ue-edit';
import { UEFiltersPage } from './ue-filters';
import { UserData } from '../../providers/user-data';
import { LicenseplateProvider } from '../../providers/licenseplate/licenseplate';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import moment from 'moment';

@Component({
  selector: 'ue-search',
  templateUrl: 'ue-search.html'
})
export class UESearchPage {
  actionSheet: ActionSheet;
  ues = [];
  searchTimeout;
  strFound:string;
  viewmode = 'list';
  plateupdateTimer;

  baseurlbeweisbilder;


  constructor( public common: CommonData
              , public events:Events
              , public actionSheetCtrl: ActionSheetController
              , public navCtrl: NavController
              , public http: Http
              , public ueData: UEData
              , public config: Config
              , public userData: UserData
              , public popoverCtrl:PopoverController
              , public toastCtrl: ToastController
              , private lpProvider: LicenseplateProvider
              ){
    //this.searchQuery = moment().format("YYYY-MM-DD");
    this.ueData.searchQuery = "last 20";
    this.baseurlbeweisbilder = this.common.baseurlbeweisbilder;

    this.events.subscribe('ue:search', () => {
      this.doSearch();
    });
    this.events.publish('ue:search');
    

  }

  openFilters(myEvent, data) {
    let popover = this.popoverCtrl.create(UEFiltersPage);
    popover.present({
      ev: myEvent
    });
  }  
  ionViewWillEnter() {
    if(this.ueData.updateRequired){
    }
  }    
  doSearch(){
      this.strFound = "0";
      Promise.all([    
          this.ueData.search(this.ueData.searchQuery),            
        ]).then(data => {
          //console.log(this.ueData.searchdata);
          this.ues = this.ueData.searchdata;    
          this.strFound = this.ues.length.toString();       
        });
  }

  toggleview(){
    if(this.viewmode == 'list')
    {
      this.viewmode = 'grid';
    }
    else{
      this.viewmode = 'list';
    }
  }

  updateplate(ue){

    
    if (this.plateupdateTimer) {
      clearTimeout(this.plateupdateTimer);
    }
    this.plateupdateTimer = setTimeout(() => {
      Promise.all([
        this.ueData.update(ue),            
      ]).then(data => {
        //console.log(data);
        //let toastCtrl : ToastController;
        let toast = this.toastCtrl.create({
          message: 'Autonummer gespeichert',
          position: 'top',
          cssClass: 'toast-error',
          duration: 1000
        });
        toast.present();          
        //refresh.complete();     
      });         
      this.plateupdateTimer = null;
    }, 2000);     
   }  

  getItems(ev: any) {
    // Reset items back to all of the items
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {  
      //this.searchQuery = ev.target.value;
      this.doSearch();
    }, 1000);  
    
/*
    this.initializeItems();

    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (item.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
    */
  }  
  
  showUEDetail(ue) {
    this.navCtrl.push(UEEditPage, ue);
    if(!this.common.wifierror){
      //this.navCtrl.push(UECreatePage, pp);
    }
    else{
      this.common.showWifiError(); 
    }
  }

  findLicenseplate(ue, filename){
    let url = this.baseurlbeweisbilder+filename;
    this.lpProvider.remoteFindLicenseplateByURL(url)
    .subscribe(data => {
      let response = data.json();
      //console.log(response.results);
      if(response.results.length>0){
        let conf = 0;
        let selindex = 0;
        for(let i=0; i<response.results.length; i++){
          if(response.results[i].confidence>conf){
            selindex = i;
          }
        }
        ue.autonummer = response.results[selindex].plate;
        this.updateplate(ue);
      }


    }, error => {
      console.log('HTTP Error, no answer');
      console.log(error);
    });        
  }





}



// WEBPACK FOOTER //
// ./src/pages/ue-list/ue-search.ts